import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { fg } from '@atlaskit/platform-feature-flags';
import { agentRequestAnalytics } from '../util/analytics';
import { getPageTime } from '../util/performance';
import CachingClient from './CachingClient';
import { getErrorAttributes } from './errorUtils';
var createHeaders = function createHeaders(product, cloudId, isBodyJson) {
  var headers = new Headers({
    'X-Product': product,
    'X-Experience-Id': 'profile-card',
    'X-Cloudid': cloudId || ''
  });
  if (isBodyJson) {
    headers.set('Content-Type', 'application/json');
  }
  return headers;
};
var RovoAgentCardClient = /*#__PURE__*/function (_CachingClient) {
  function RovoAgentCardClient(options) {
    var _this;
    _classCallCheck(this, RovoAgentCardClient);
    _this = _callSuper(this, RovoAgentCardClient, [options]);
    _this.options = options;
    return _this;
  }
  _inherits(RovoAgentCardClient, _CachingClient);
  return _createClass(RovoAgentCardClient, [{
    key: "basePath",
    value: function basePath() {
      return fg('pt-deprecate-assistance-service') ? '/gateway/api/assist/rovo/v1/agents' : '/gateway/api/assist/agents/v1';
    }
  }, {
    key: "makeRequest",
    value: function makeRequest(id, cloudId) {
      var product = this.options.productIdentifier || 'rovo';
      var headers = createHeaders(product, this.options.cloudId);
      if (id.type === 'identity') {
        return fetch(new Request("".concat(this.basePath(), "/accountid/").concat(id.value), {
          method: 'GET',
          credentials: 'include',
          mode: 'cors',
          headers: headers
        })).then(function (response) {
          return response.json();
        });
      }
      return fetch(new Request("".concat(this.basePath(), "/").concat(id.value), {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        headers: headers
      })).then(function (response) {
        return response.json();
      });
    }
  }, {
    key: "getProfile",
    value: function getProfile(id, analytics) {
      var _this2 = this;
      if (!id.value) {
        return Promise.reject(new Error('Id is missing'));
      }
      if (!this.options.cloudId) {
        return Promise.reject(new Error('cloudId is missing'));
      }
      var cache = this.getCachedProfile(id.value);
      if (cache) {
        return Promise.resolve(cache);
      }
      return new Promise(function (resolve, reject) {
        var startTime = getPageTime();
        if (analytics) {
          analytics(agentRequestAnalytics('triggered'));
        }
        _this2.makeRequest(id, _this2.options.cloudId || '').then(function (data) {
          if (_this2.cache) {
            _this2.setCachedProfile(id.value, data);
          }
          if (analytics) {
            analytics(agentRequestAnalytics('succeeded', 'request', {
              duration: getPageTime() - startTime,
              gateway: true
            }));
          }
          resolve(data);
        }).catch(function (error) {
          if (analytics) {
            analytics(agentRequestAnalytics('failed', 'request', _objectSpread(_objectSpread({
              duration: getPageTime() - startTime
            }, getErrorAttributes(error)), {}, {
              gateway: true
            })));
          }
          reject(error);
        });
      });
    }
  }, {
    key: "deleteAgent",
    value: function deleteAgent(agentId, analytics) {
      var _this3 = this;
      if (!this.options.cloudId) {
        return Promise.reject(new Error('cloudId is missing'));
      }
      return new Promise(function (resolve, reject) {
        var startTime = getPageTime();
        var product = _this3.options.productIdentifier || 'rovo';
        if (analytics) {
          analytics(agentRequestAnalytics('triggered'));
        }
        var headers = createHeaders(product, _this3.options.cloudId);
        fetch(new Request("".concat(_this3.basePath(), "/").concat(agentId), {
          method: 'DELETE',
          credentials: 'include',
          mode: 'cors',
          headers: headers
        })).then(function () {
          if (analytics) {
            analytics(agentRequestAnalytics('succeeded', 'deleteAgent', {
              duration: getPageTime() - startTime,
              gateway: true
            }));
          }
          resolve();
        }).catch(function (error) {
          if (analytics) {
            analytics(agentRequestAnalytics('failed', 'deleteAgent', _objectSpread(_objectSpread({
              duration: getPageTime() - startTime
            }, getErrorAttributes(error)), {}, {
              gateway: true
            })));
          }
          reject(error);
        });
      });
    }
  }, {
    key: "setFavouriteAgent",
    value: function setFavouriteAgent(agentId, isFavourite, analytics) {
      var _this4 = this;
      if (!this.options.cloudId) {
        return Promise.reject(new Error('cloudId is missing'));
      }
      return new Promise( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
          var startTime, product, actionSubjectId, requestMethod, headers;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                startTime = getPageTime();
                product = _this4.options.productIdentifier || 'rovo';
                actionSubjectId = isFavourite ? 'favourite' : 'unfavourite';
                requestMethod = isFavourite ? 'POST' : 'DELETE';
                if (analytics) {
                  analytics(agentRequestAnalytics('triggered', 'actionSubjectId'));
                }
                headers = createHeaders(product, _this4.options.cloudId);
                _context.next = 8;
                return fetch(new Request("".concat(_this4.basePath(), "/").concat(agentId, "/favourite"), {
                  method: requestMethod,
                  credentials: 'include',
                  mode: 'cors',
                  headers: headers
                })).then(function () {
                  if (analytics) {
                    analytics(agentRequestAnalytics('succeeded', actionSubjectId, {
                      duration: getPageTime() - startTime,
                      gateway: true
                    }));
                  }
                  resolve();
                }).catch(function (error) {
                  if (analytics) {
                    analytics(agentRequestAnalytics('failed', actionSubjectId, _objectSpread(_objectSpread({
                      duration: getPageTime() - startTime
                    }, getErrorAttributes(error)), {}, {
                      gateway: true
                    })));
                  }
                  reject(error);
                });
              case 8:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "getPermissions",
    value: function getPermissions(id, fireAnalytics) {
      var _this5 = this;
      if (!this.options.cloudId) {
        return Promise.reject(new Error('cloudId is missing'));
      }
      return new Promise(function (resolve, reject) {
        var startTime = getPageTime();
        var product = _this5.options.productIdentifier || 'rovo';
        if (fireAnalytics) {
          fireAnalytics(agentRequestAnalytics('triggered'));
        }
        var headers = createHeaders(product, _this5.options.cloudId, true);
        fetch(new Request("/gateway/api/assist/api/rovo/v2/permissions/agents/".concat(id), {
          method: 'POST',
          credentials: 'include',
          mode: 'cors',
          headers: headers,
          body: JSON.stringify({
            permission_ids: ['AGENT_CREATE', 'AGENT_UPDATE', 'AGENT_DELETE', 'AGENT_DEACTIVATE', 'AGENT_READ']
          })
        })).then(function (response) {
          return response.json();
        }).then(function (data) {
          if (fireAnalytics) {
            fireAnalytics(agentRequestAnalytics('succeeded', 'getAgentPermissions', {
              duration: getPageTime() - startTime,
              gateway: true
            }));
          }
          resolve(data);
        }).catch(function (error) {
          if (fireAnalytics) {
            fireAnalytics(agentRequestAnalytics('failed', 'getAgentPermissions', _objectSpread(_objectSpread({
              duration: getPageTime() - startTime
            }, getErrorAttributes(error)), {}, {
              gateway: true
            })));
          }
          reject(error);
        });
      });
    }
  }]);
}(CachingClient);
export { RovoAgentCardClient as default };